import Vue from 'vue';
import VueTagManager from 'vue-tag-manager';
import { GTM_KEY } from '@/config';

Vue.use(VueTagManager, {
    gtmId: GTM_KEY,
});
